import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { FlexColumn } from 'src/components/Atoms/FlexBox';
import styled from 'src/Theme/styled';
import Image from 'next/image';
import { useTheme } from '@mui/material/styles';
import { BlocksContent } from '@strapi/blocks-react-renderer';
import RichText from 'src/components/Atoms/RichText/RichText';
import Typography from '@mui/material/Typography';
export interface DrawerContentItemProps {
  item?: {
    documentId: string;
    description?: string | null;
    richText?: BlocksContent | null;
    title?: string | null;
    subtitle?: string | null;
    media?: {
      alternativeText?: string | null;
      mime?: string | null;
      url?: string | null;
      formats?: {
        thumbnail?: {
          url?: string | null;
        } | null;
      } | null;
    } | null;
  } | null;
}
const MediaContainer = styled(FlexColumn)(({
  theme
}) => ({
  width: '100%',
  borderRadius: theme.sizes.radius.xl,
  overflow: 'clip',
  position: 'relative',
  aspectRatio: '16 / 9'
}));
export const DrawerContentItem: React.FC<DrawerContentItemProps> = t0 => {
  const $ = _c(21);
  const {
    item
  } = t0;
  const theme = useTheme();
  if (!item) {
    return null;
  }
  const isVideo = item.media?.mime?.startsWith("video/");
  const videoUrl = isVideo ? item.media?.url : null;
  const image = !isVideo ? item.media?.url : null;
  const title = item.title || "";
  const t1 = theme.sizes.spacing["08"];
  let t2;
  if ($[0] !== t1) {
    t2 = {
      gap: t1,
      width: "100%"
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== image || $[3] !== item.media?.alternativeText || $[4] !== item.media?.url || $[5] !== theme.breakpoints || $[6] !== title || $[7] !== videoUrl) {
    t3 = (videoUrl || image) && <MediaContainer>{videoUrl ? <video controls={true} title={item.media?.alternativeText || title} style={{
        width: "100%",
        height: "100%"
      }}><source src={videoUrl} type="video/mp4" /><Image src={item.media?.url || ""} alt={item.media?.alternativeText || title} fill={true} style={{
          objectFit: "cover"
        }} sizes={`(max-width: ${theme.breakpoints.values.lg}px) 100vw, 50vw`} /></video> : <Image src={item.media?.url || ""} alt={item.media?.alternativeText || title} fill={true} style={{
        objectFit: "cover"
      }} sizes={`(max-width: ${theme.breakpoints.values.lg}px) 100vw, 50vw`} />}</MediaContainer>;
    $[2] = image;
    $[3] = item.media?.alternativeText;
    $[4] = item.media?.url;
    $[5] = theme.breakpoints;
    $[6] = title;
    $[7] = videoUrl;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== item.subtitle) {
    t4 = item.subtitle && <Typography variant="heading-lg">{item.subtitle}</Typography>;
    $[9] = item.subtitle;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== item.description) {
    t5 = item.description && <Typography variant="body-base" sx={_temp}>{item.description}</Typography>;
    $[11] = item.description;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== item.richText) {
    t6 = item.richText && <RichText content={item.richText || ""} />;
    $[13] = item.richText;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t2 || $[16] !== t3 || $[17] !== t4 || $[18] !== t5 || $[19] !== t6) {
    t7 = <FlexColumn sx={t2}>{t3}{t4}{t5}{t6}</FlexColumn>;
    $[15] = t2;
    $[16] = t3;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  return t7;
};
export default DrawerContentItem;
function _temp(theme_0) {
  return {
    color: theme_0.colors.text.secondary,
    whiteSpace: "pre-line"
  };
}